/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Card_Lots_SuffixInputs */

const vi_note_card_lots_suffix = /** @type {(inputs: Note_Card_Lots_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lô`)
};

/**

* @param {Note_Card_Lots_SuffixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_card_lots_suffix = /** @type {((inputs?: Note_Card_Lots_SuffixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Card_Lots_SuffixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_card_lots_suffix(inputs)
});